import React, {useEffect, useState} from "react";
import {MdOutlineInfo} from "react-icons/md";
import axios from "axios";
import {useSelector} from "react-redux";
import {useParams} from "react-router";
import {ErrorToaster, SuccessToaster} from "../../../../shared/toaster";
import {Field} from "../../../../components/fouladyar/field/field";
import {Divider} from "../../signal/tabs/signals";
import '../styles.css'
import {requestTemplate} from "../models/emptyRequest";
import {MoneySeparator} from "../../../../shared/moneySeparator";
import {toFarsiNumber} from "../../../../shared/toFarsiNumber";

export const InfoPage = () => {


    const auth = useSelector((state) => state.auth);
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsloading] = useState(false);
    const {id} = useParams();

    const [data, setData] = useState(requestTemplate)
    const [cost, setCost] = useState()
    const [description, setDescription] = useState()


    async function submit() {
        try {
            setIsSaving(true)
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/orders/request-order-new-strategy-code/register-price/${id}`,
                {
                    amount: cost,
                    admin: {
                        description: description
                    }
                },
                {headers: {"authorization": `Bearer ${auth.token}`}}
            );

            if (res.data.statusCode === 200) {
                SuccessToaster({message: 'ذخیره اطاعات پایه ربات با موفقیت ثبت شد'})

                setIsSaving(false);
            }


        } catch (e) {
            setIsSaving(false)
            ErrorToaster({message: 'ذخیره اطلاعات با مشکل مواجه شده است'})
        }

    }


    async function loadData() {
        try {
            setIsloading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/orders/request-order-new-strategy-code/admin/${id}`,
                {
                    headers: {
                        "authorization": `Bearer ${auth.token}`
                    }
                }
            );

            if (res.data.statusCode === 200) {
                setData(res.data.data?.extras)
                setCost(res.data.data?.amount)
                setDescription(res.data.data?.admin?.description)
                setIsloading(false)
            }


        } catch (e) {
            ErrorToaster(e);
            setIsloading(false)
        }


    }

    useEffect(() => {
        loadData()
    }, [])

    return (
        <div>
            <div className="container-fluid select-plan-container">

                <h1 className={'pt-3'}>{"بررسی درخواست سفارش کد"}</h1>

                <div className="spacer"/>
                <h3 style={{border: 'unset'}}>
                    کاربر ادمین، لطفا درخواست سفارش کد مشتری را بر اساس قیمت گذاری ها بررسی دقیق کرده و سپس قیمت نهایی
                    را وارد کنید.
                </h3>
                <p>
                    در صورتی که سوال و یا ابهام در مورد قیمت گذاری داشتید،‌ حتما این موضوع را با مسئول اصلی سایت در میان
                    بگذارید. در غیر این صورت پس از بررسی کامل درخواست مشتری قیمت نهایی را در فرم زیر وارد کنید.
                </p>
            </div>


            <h3 className={"info-page-segment-title"}>اطلاعات کلی</h3>
            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>نام و نام خانوادگی</div>
                <div className={'info-page-segment-title-value'}>{data.firstName || '-'} {data.lastName || '-'}</div>
            </h3>
            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>آدرس ایمیل</div>
                <div className={'info-page-segment-title-value'}>{data.email || '-'}</div>
            </h3>
            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>شماره تماس</div>
                <div className={'info-page-segment-title-value'}>{data.phone || '-'}</div>
            </h3>


            <Divider/>

            <h3 className={"info-page-segment-title"}>قواعد استراتژي</h3>
            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>نوع سفارش</div>
                <div className={'info-page-segment-title-value'}>{data.type || '-'}</div>
            </h3>
            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>اندیکاتورها و اوسیلاتورها</div>
                <div className={'info-page-segment-title-value'}>{data.indicators || '-'}</div>
            </h3>
            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>شرایط ورود</div>
                <div className={'info-page-segment-title-value'}>{data.entryConditions || '-'}</div>
            </h3>
            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>تاییدیه ورود</div>
                <div className={'info-page-segment-title-value'}>{data.entryConfirmation || '-'}</div>
            </h3>

            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>شرایط خروج</div>
                <div className={'info-page-segment-title-value'}>{data.exitConditions || '-'}</div>
            </h3>

            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>تریلینگ استاپ</div>
                <div className={'info-page-segment-title-value'}>{data.trailingStop || '-'}</div>
            </h3>
            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>مدیریت اسپرد</div>
                <div className={'info-page-segment-title-value'}>{data.spreadManagement || '-'}</div>
            </h3>

            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>توضیحات تکیمیلی</div>
                <div className={'info-page-segment-title-value'}>
                    <div dangerouslySetInnerHTML={{__html: data.description}}/>
                </div>
            </h3>


            <Divider/>

            <h3 className={"info-page-segment-title"}>مدیریت ریسک و سرمایه</h3>
            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>حجم معامله</div>
                <div className={'info-page-segment-title-value'}>{data.tradeVolume || '-'} </div>
            </h3>
            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>حداکثر ضرر مجاز در روز / هفته / ماه</div>
                <div className={'info-page-segment-title-value'}>{data.maxLossModel || '-'} </div>
            </h3>
            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>نحوه محاسبه حجم معامله (لات سایز)</div>
                <div className={'info-page-segment-title-value'}>{data.lotSizeCalculation || '-'}</div>
            </h3>
            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>مدیریت دراودان</div>
                <div className={'info-page-segment-title-value'}>{data.drawdownManagement || '-'}</div>
            </h3>


            <Divider/>


            <h3 className={"info-page-segment-title"}>سایر تنظیمات</h3>
            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>امکان ترید دستی</div>
                <div className={'info-page-segment-title-value'}>{data.manualTrading || '-'} </div>
            </h3>
            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>امکان مدیریت چند معامله همزمان</div>
                <div className={'info-page-segment-title-value'}>{data.multiTradeManagement || '-'} </div>
            </h3>

            <Divider/>

            <h3 className={"info-page-segment-title"}>نیاز های اضافی</h3>
            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>آیا نیاز به پنل مدیریت و تنظیمات دارد؟</div>
                <div
                    className={'info-page-segment-title-value'}>{data.adminPanelRequired ? 'نیاز دارم' : 'نیاز ندارم' || '-'} </div>
            </h3>
            <h3 className={"info-page-value-item"}>
                <div className={'info-page-segment-title-key'}>آیا به سیستم اطلاع رسانی نیاز دارید؟</div>
                <div
                    className={'info-page-segment-title-value'}>{data.notificationSystem ? 'نیاز دارم' : 'نیاز ندارم' || '-'}</div>
            </h3>

            <Divider/>

            <h3 className={"info-page-segment-title"}>بررسی تعرفه توسعه کد استراتژی</h3>
            <p>
                با مراجعه به جدول تعرفه های خدمات و سرویس های سایت قیمت نهایی توسعه این ربات را در فیلد زیر وارد کنید.
                سپس توضیحات تکمیلی تر جهت آگاهی بیشتر مشتری از هزینه ها و موارد دیگر را وارد کنید.
            </p>
            <div className="kyc-form-row d-flex flex-column" style={{gap: '5px'}}>
                <Field
                    label={"هزینه توسعه"}
                    id={"cost"}
                    name={"cost"}
                    type={'number'}
                    defaultValue={cost}
                    value={cost}
                    onChange={(e) => {
                        setCost(e)
                    }}
                    onBlur={(e) => {
                    }}
                />
                <div className="d-flex flex-row" style={{gap: '10px'}}>
                    <MdOutlineInfo size={20} color={"#ccc"}/>
                    <div className='d-flex flex-row justify-content-between w-100'>
                        <span>
                            پس از بررسی دقیق تعرفه ها قیمت نهایی را ثبت کنید. دقت کنید قیمت به تومان وارد شود
                        </span>
                        <span style={{color: '#f4bd0e'}}>
                            {toFarsiNumber(MoneySeparator(cost || 0))} ریال
                        </span>
                    </div>
                </div>
            </div>
            <div className="kyc-form-row d-flex flex-column" style={{gap: '5px'}}>
                <Field
                    className="w-100"
                    label={"توضیحات ادمین"}
                    id={"description"}
                    name={"description"}
                    type={'editor'}
                    defaultValue={description}
                    value={description}
                    onChange={(e) => {
                        setDescription(e)
                    }}
                    onBlur={(e) => {

                    }}
                />
            </div>


            <button disabled={isSaving} className="btn green-button w-100" type="button" onClick={() => {
                submit()
            }}>
                ثبت درخواست
            </button>
        </div>
    );
};